export default __webpack_public_path__ + "static/radoslaww-d1f820790527cc614ee67db24b4e9848.jpg";